export default class CityCedexDto {
    constructor(obj = {}) {
        this.cedexCode = obj.cedexCode
        this.cityCode = obj.cityCode
        this.cedex = obj.cedex
    }
}